import { API } from "../urls";

const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: "include" };

const toQuery = (params) => {
    const q = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") q.append(k, v);
    });
    const s = q.toString();
    return s ? `?${s}` : "";
};

// ─── COMPANY_ADMIN ───────────────────────────────────────────

export const getMyReferralSummary = async () => {
    const res = await fetch(API.referral_me, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Davet bilgileri alınamadı");
    return res.json();
};

export const getMyReferrals = async (page = 0, size = 20) => {
    const res = await fetch(API.referrals + toQuery({ page, size }), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Davetler yüklenemedi");
    return res.json();
};

// Davetle gelen firmanın ilk ücretli paketinde bekleyen hediye ayı (paket ekranları için).
export const getReferralOffer = async () => {
    const res = await fetch(API.referral_offer, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Davet hediyesi bilgisi alınamadı");
    return res.json();
};

// ─── PUBLIC (kayıt sayfası) ──────────────────────────────────

export const validateReferralCode = async (code) => {
    const res = await fetch(API.referral_validate + toQuery({ code }), { headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Davet kodu kontrol edilemedi");
    return res.json();
};

// ─── SUPER_ADMIN ─────────────────────────────────────────────

export const adminGetReferralSettings = async () => {
    const res = await fetch(API.admin_referral_settings, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Ayarlar yüklenemedi");
    return res.json();
};

export const adminUpdateReferralSettings = async (payload) => {
    const res = await fetch(API.admin_referral_settings, {
        method: "PUT",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Ayarlar kaydedilemedi");
    return res.json();
};

export const adminGetReferrals = async (params) => {
    const res = await fetch(API.admin_referrals + toQuery(params), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Referanslar yüklenemedi");
    return res.json();
};

export const adminCancelReferral = async (id, reason) => {
    const res = await fetch(API.admin_referral_cancel(id), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ reason }),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Referans iptal edilemedi");
    return res.json();
};
